const LayoutSettings = {
  leftSidebar: {
    show: true,
    mode: 'full',      // full, close, compact, mobile
    theme: 'md3Green', // MD3 Navigation Drawer uses surface colors from theme
    bgImgURL: ''       // No background image — MD3 uses flat tonal surfaces
  },
  topbar: {
    show: true,
    fixed: true,
    theme: 'md3Green'  // MD3 App Bar — surface color
  }
};

export default LayoutSettings;
